export enum GiveBoxEvent {
	Created = 'bonus-created',
	Deleted = 'bonus-deleted',
	Open = 'init-give-recognition',
}

export enum AmplitudeEvent {
	MeaningfulMeterTips = 'Click Expand Meaningful Meter Tips',
}
